<template>
  <list-view class="component-photo-panel">
    <div class="component-photo"
      v-for="component in components"
      v-bind:style="{ backgroundImage: 'url(' + component.photoUrl + ')' }"
      v-on:click="componentPhotoClick(component.detailPhotoUrl)"
      >
    </div>
  </list-view>
</template>

<script>
import listView from 'components/list-view';

const photoUrlBase = 'static/images/component/photo/';
const detailPhotoUrlBase = 'static/images/component/detail_photo/';

export default {
  name: 'component-photo-panel',
  props: ['productSummary'],
  data() {
    return {
      photoUrlBase
    };
  },
  components: {
    listView
  },
  computed: {
    components() {
      if (!this.productSummary || !this.productSummary.components) {
        return [];
      }

      const components = this.productSummary.components;
      return Object.keys(components).reduce((result, key) => {
        return result.concat(components[key].components);
      }, []).filter((component) => {
        return !!component.id;
      }).map((component) => {
        const variationValues = component.variationValues;
        const variationSuffix =
        Object.keys(variationValues).reduce((result, variationName) => {
          return `${result}-${variationValues[variationName]}`;
        }, '');
        return {
          photoUrl: `${photoUrlBase + component.id}${variationSuffix}.png`,
          detailPhotoUrl:
            `${detailPhotoUrlBase + component.id}${variationSuffix}.png`
        };
      });
    }
  },
  methods: {
    componentPhotoClick(photoUrl) {
      this.$emit('component-photo-click', photoUrl);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.component-photo {
  width: 50px;
  height: 50px;
  margin: 20px 5px;
  background-size: cover;
  background-color: #f2f2f2;
  border: 1px solid silver;
  box-sizing: border-box;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// component-photo-panel.vue?5711b420